import { bl_pos_terminal_device_RowClass } from '../../../dbschema/bl_pos_terminal_device.model';
import {BaseContainerModel} from '../../base-container.model';


export class PosTerminalDeviceContainerModel extends BaseContainerModel {
  bl_pos_terminal_device: bl_pos_terminal_device_RowClass = new bl_pos_terminal_device_RowClass();
}
